import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ToastContext } from '@weezevent/nacre';
import Subscription from '../../../../models/subscription';

import { useTranslation } from 'react-i18next';

export default function DeleteModal({ show, sync, onClose, organizationId, subscription }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const onDelete = React.useCallback(() => {
        new Subscription({ id: subscription.id })
            .delete({ organizationId })
            .then(() => {
                sync({ cache: false, allow_cache: false });
                toast.success(t('ticket.common.cta.removed'));
            })
            .catch(() => {
                toast.error(t('ticket.webservice.list.modal.error'));
            })
            .finally(() => {
                onClose();
            });
    }, [subscription, organizationId, onClose, sync]);

    return (
        <Modal
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.list.modal.title')}
            submitButton={
                <Button primary onClick={onDelete}>
                    {t('ticket.common.cta.yes')}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t('ticket.common.cta.no')}</Button>}
        >
            {t('ticket.webservice.list.modal.body')}
        </Modal>
    );
}

DeleteModal.propTypes = {
    organizationId: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    triggerRefetch: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired
};
